'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SGBarChart = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recharts = require('recharts');

var _barChartUtils = require('./bar-chart-utils');

var utils = _interopRequireWildcard(_barChartUtils);

var _chartTooltipWrapper = require('../chart-tooltip-wrapper');

var _chartTooltipWrapper2 = _interopRequireDefault(_chartTooltipWrapper);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _logger = require('../../../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = new _logger2.default();
var axisProps = { tickSize: utils.LABELS_OFFSET, tickLine: false, axisLine: false };

var SGBarChart = exports.SGBarChart = function SGBarChart(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === undefined ? [] : _ref$data,
      _ref$elementsIds = _ref.elementsIds,
      elementsIds = _ref$elementsIds === undefined ? [] : _ref$elementsIds,
      filteredElementsIds = _ref.filteredElementsIds,
      _ref$barSize = _ref.barSize,
      barSize = _ref$barSize === undefined ? 10 : _ref$barSize,
      _ref$barGap = _ref.barGap,
      barGap = _ref$barGap === undefined ? 0 : _ref$barGap,
      _ref$layout = _ref.layout,
      layout = _ref$layout === undefined ? 'vertical' : _ref$layout,
      height = _ref.height,
      axisData = _ref.axisData,
      renderTooltip = _ref.renderTooltip,
      tickFormatterX = _ref.tickFormatterX,
      tickFormatterY = _ref.tickFormatterY,
      _ref$xAxisWidth = _ref.xAxisWidth,
      xAxisWidth = _ref$xAxisWidth === undefined ? 30 : _ref$xAxisWidth,
      _ref$yAxisWidth = _ref.yAxisWidth,
      yAxisWidth = _ref$yAxisWidth === undefined ? 50 : _ref$yAxisWidth,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;

  var categoryGapSize = utils.GROUPS_GAP_INDEX * barSize;
  var categoriesLength = data.length;
  var elementsLength = filteredElementsIds.length;
  var isLayoutVertical = layout === 'vertical';

  var calculatedHeight = height;

  if (!calculatedHeight && isLayoutVertical) {
    calculatedHeight = utils.calculateChartHeight({
      categoriesLength: categoriesLength,
      elementsLength: elementsLength,
      barSize: barSize,
      categoryGapSize: categoryGapSize
    });
  }

  if (!height && !isLayoutVertical) {
    logger.log('For horizontal bar charts you must specify height in props.');
  }

  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(
      _recharts.ResponsiveContainer,
      {
        height: calculatedHeight
      },
      _react2.default.createElement(
        _recharts.BarChart,
        {
          barGap: barGap,
          barCategroryGap: categoryGapSize,
          layout: layout,
          margin: { top: 0, bottom: 0 },
          data: data
        },
        isLayoutVertical ? _react2.default.createElement(_recharts.CartesianGrid, {
          vertical: false // removes vertical lines
          , horizontalPoints: utils.generateGridLinePoints({ size: calculatedHeight, elementsLength: elementsLength, barSize: barSize })
        }) : _react2.default.createElement(_recharts.CartesianGrid, { vertical: false }),
        _react2.default.createElement(_recharts.XAxis, _extends({}, axisProps, {
          type: utils.getDataType(data, axisData.x),
          dataKey: axisData.x,
          width: xAxisWidth,
          tickFormatter: function tickFormatter(value) {
            if (tickFormatterX) {
              return tickFormatterX(value);
            }

            return value;
          }
        })),
        _react2.default.createElement(_recharts.YAxis, _extends({}, axisProps, {
          type: utils.getDataType(data, axisData.y),
          dataKey: axisData.y,
          width: yAxisWidth,
          tickFormatter: function tickFormatter(value) {
            if (tickFormatterY) {
              return tickFormatterY(value);
            }

            return value;
          }
        })),
        renderTooltip && (0, _chartTooltipWrapper2.default)({ renderTooltip: renderTooltip }),
        filteredElementsIds.map(function (fieldId) {
          var barIndex = elementsIds.indexOf(fieldId);

          return _react2.default.createElement(_recharts.Bar, {
            barSize: barSize,
            key: fieldId + '-' + barIndex,
            dataKey: fieldId,
            fill: (0, _utils2.default)(barIndex)
          });
        })
      )
    )
  );
};

var layoutOptions = ['vertical', 'horizontal'];

SGBarChart.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
  axisData: _propTypes2.default.shape({
    x: _propTypes2.default.string.isRequired,
    y: _propTypes2.default.string.isRequired
  }).isRequired,
  tickFormatterX: _propTypes2.default.func,
  tickFormatterY: _propTypes2.default.func,
  layout: _propTypes2.default.oneOf(layoutOptions),
  height: _propTypes2.default.number,
  barSize: _propTypes2.default.number,
  barGap: _propTypes2.default.number,
  xAxisWidth: _propTypes2.default.number,
  yAxisWidth: _propTypes2.default.number,
  renderTooltip: _propTypes2.default.func,
  elementsIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  filteredElementsIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  style: _propTypes2.default.object
};

exports.default = SGBarChart;